// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__NxDnt","large":"styles_large__MEVZA"};